import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-md card-ive p-8" data-testid="login-form">
        <div className="type-label text-[#C8102E] mb-3">Ironveil Era</div>
        <h1 className="font-display text-2xl mb-6">Admin Sign In</h1>
        <label className="block mb-4">
          <div className="type-meta text-[#888] mb-2">Email</div>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3" data-testid="login-email" />
        </label>
        <label className="block mb-6">
          <div className="type-meta text-[#888] mb-2">Password</div>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3" data-testid="login-password" />
        </label>
        <button disabled={loading} className="btn-primary w-full" data-testid="login-submit">{loading ? "Signing in…" : "Sign In"}</button>
        <div className="mt-5 text-center"><Link to="/admin/forgot-password" className="btn-text text-[#a0a0a0]" data-testid="forgot-password-link">Forgot password?</Link></div>
      </form>
    </div>
  );
}
